import Vue from 'vue';

let EventTypeEnum = {
    FailedLogin: 'FailedLogin',
    SuccessfulLogin: 'SuccessfulLogin'
};

let EventTypeOptions = [
    { value: EventTypeEnum.FailedLogin, text: Vue.i18n.$t('[[[Nieudane logowanie]]]') },
    { value: EventTypeEnum.SuccessfulLogin, text: Vue.i18n.$t('[[[Udane logowanie]]]') }
];

class EventTypeTranslator
{
    static translate(enumValue)
    {
        switch (enumValue)
        {
            case EventTypeEnum.FailedLogin:
                return Vue.i18n.$t('[[[Nieudane logowanie]]]');
            case EventTypeEnum.SuccessfulLogin:
                return Vue.i18n.$t('[[[Udane logowanie]]]');
            default:
                return Vue.i18n.$t('[[[Inne zdarzenie]]]');
        }
    }
}

export {
    EventTypeEnum,
    EventTypeOptions,
    EventTypeTranslator
};
